<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated" [activationErrors]="activationService.activateErrors"
    [entityName]="account.name" [activationService]="activationService"></prox-activation-checklist>
  <!-- Width matches the grid below (w-2/3) so the Analyze button right-aligns with the grid edge. -->
  <div class="qb-list-actions w-2/3">
    <p-button (onClick)="onPugAdd()" size="small" label="Add Program User Group" icon="pi pi-plus"
      [disabled]="isReadOnly()" id="pugAddBtn"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
    <div class="ml-auto flex items-center gap-4">
      <div class="flex items-center">
        <p-checkbox [(ngModel)]="showInactivePugs" [binary]="true" (onChange)="onShowInactiveChanged()"
          name="showInactivePugs" inputId="showInactivePugs"></p-checkbox>
        <label for="showInactivePugs" class="ml-2">Show Inactive?</label>
      </div>
      <p-button (onClick)="analyzeMenu.toggle($event)" size="small" label="Analyze" icon="pi pi-chart-bar"
        iconPos="left" severity="secondary" [outlined]="true" id="pugAnalyzeBtn"></p-button>
      <p-menu #analyzeMenu [model]="analyzeItems" [popup]="true" appendTo="body"></p-menu>
    </div>
  </div>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full w-full" [panelSizes]="[40, 60]">
    <ng-template pTemplate>
      <div class="flex w-full h-full">
        <div class="w-2/3 h-full mt-1 pb-4">
          <prox-ag-grid gridId="programUserGroupsGrid" [gridOptions]="pugGridOptions" [hasColSizeButtons]="false"
            [hasClearFiltersButton]="true"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <p-tabView class="pt-3 grow qb-tabview" [(activeIndex)]="tabViewIndex" (onChange)="onTabChange($event)">
        <p-tabPanel header="Users">
          <div class="flex flex-col w-full h-full">
            <div class="qb-child-actions">
              <p-button [disabled]="!canAttachUsers()" (onClick)="onPugmAdd()"
                [pTooltip]="attachUsersDisabledReason()" tooltipPosition="bottom"
                label="Add Users to Program User Group" icon="pi pi-plus" size="small" id="pugmAddBtn"></p-button>
            </div>
            <div class="grow h-full">
              <prox-ag-grid gridId="programUsersGrid" [gridOptions]="pugmGridOptions" [rowData]="pugms">
              </prox-ag-grid>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Budgets">
          <div class="grow w-2/3 h-full">
            <prox-budget-items [accountId]="accountId" [budgets]="programUserGroupBudgets" [joBudgetLogs]="joBudgetLogs"
              addLabel="Add Budget Items to Program User Group" [createEntityFn]="createPugBudget.bind(this)"
              [isReadOnly]="isReadOnly()"></prox-budget-items>
          </div>
        </p-tabPanel>
      </p-tabView>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>